// test860
(860 && 0);
